import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="guarantee" ref={ref} className="w-full bg-cream py-8 md:py-16 px-4" data-id="element-186">
      <div className="max-w-4xl mx-auto" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="bg-white p-6 md:p-10 rounded-lg shadow-xl border-4 border-gold" data-id="element-188">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6 md:mb-8 text-center" data-id="element-189">
            YOUR GUARANTEE
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed" data-id="element-190">
            <p data-id="element-191">
              You have probably bought resources before that looked great and
              underdelivered.
            </p>

            <p className="text-lg md:text-xl font-semibold text-navy" data-id="element-192">
              So here is the promise: open the pack. Use it for your first week
              of lessons. If it does not make Monday morning better — contact us
              and we will make it right.
            </p>

            <p className="text-xl md:text-2xl font-bold text-navy text-center pt-4 md:pt-6" data-id="element-193">
              The risk is ours. The classrooms are yours.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}